import { Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import Nav from './components/Nav';
import Footer from './components/Footer';
import Home from './pages/Home';
import Browse from './pages/Browse';
import Categories from './pages/Categories';
import Regions from './pages/Regions';
import CategoryLanding from './pages/CategoryLanding';
import RegionCategoryLanding from './pages/RegionCategoryLanding';
import FaqHub from './pages/FaqHub';
import ListingDetail from './pages/ListingDetail';
import ListBusiness from './pages/ListBusiness';
import Pricing from './pages/Pricing';
import SignIn from './pages/SignIn';
import MarineNews from './pages/MarineNews';
import MarineNewsArticle from './pages/MarineNewsArticle';
import About from './pages/About';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';

import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import EditListing from './pages/EditListing';
import ManageGallery from './pages/ManageGallery';

import Tides from './pages/Tides';
import HarbourGuide from './pages/HarbourGuide';
import FishGuide from './pages/FishGuide';
import Marketplace from './pages/Marketplace';
import MarketplaceListing from './pages/MarketplaceListing';
import MarketplaceCreate from './pages/MarketplaceCreate';
import MarketplaceSignIn from './pages/MarketplaceSignIn';
import MarketplaceDashboard from './pages/MarketplaceDashboard';

import RenewPage from './pages/RenewPage';
import RenewSuccessPage from './pages/RenewSuccessPage';
import ListSuccessPage from './pages/ListSuccessPage';
import ManageListing from './pages/ManageListing';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export default function App() {
  return (
    <div className="min-h-screen flex flex-col">
      <ScrollToTop />
      <Nav />
      <main className="pt-[60px] md:pt-16 flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/browse" element={<Browse />} />
          <Route path="/categories" element={<Categories />} />
<Route path="/regions" element={<Regions />} />
          <Route path="/category/:slug" element={<CategoryLanding />} />
<Route path="/category/:categorySlug/:regionSlug" element={<RegionCategoryLanding />} />
          <Route path="/faq" element={<FaqHub />} />
          <Route path="/listing/:categorySlug/:listingSlug" element={<ListingDetail />} />
          <Route path="/listing/:id" element={<ListingDetail />} />
          <Route path="/list" element={<ListBusiness />} />
          <Route path="/list/success" element={<ListSuccessPage />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/news" element={<MarineNews />} />
          <Route path="/news/:slug" element={<MarineNewsArticle />} />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/edit-listing" element={<EditListing />} />
          <Route path="/manage-gallery" element={<ManageGallery />} />
          <Route path="/tides" element={<Tides />} />
<Route path="/tides/:port" element={<Tides />} />
          <Route path="/fish-guide" element={<FishGuide />} />
          <Route path="/harbours" element={<HarbourGuide />} />
          <Route path="/marketplace" element={<Marketplace />} />
          <Route path="/marketplace/create" element={<MarketplaceCreate />} />
          <Route path="/marketplace/dashboard" element={<MarketplaceDashboard />} />
          <Route path="/marketplace/signin" element={<MarketplaceSignIn />} />
          <Route path="/marketplace/:slug" element={<MarketplaceListing />} />
          <Route path="/renew/:id" element={<RenewPage />} />
          <Route path="/renew/success" element={<RenewSuccessPage />} />
          <Route path="/renew/cancel" element={<RenewPage />} />
          <Route path="/manage/:slug" element={<ManageListing />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}
